import styled from "styled-components";
import {media, tokens} from "../../theme";

export const DashboardContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
    align-items: center;
    width: 80%;
`;

export const LogoWrapper = styled.div`
    text-align: center;
    margin-top: 20px;
    
    img {
        width: 280px;
        height: auto;
    }
`;

export const Header = styled.div<{ $isBigSpace: boolean }>`
    font-weight: 700;
    font-size: ${tokens.fontSize.lg};
    color: ${({theme}) => theme.palette.text.primary};
    margin-bottom: 12px;

    ${media.sm} {
        font-size: ${tokens.fontSize.lg};
    }

    ${media.md} {
        font-size: ${tokens.fontSize.xl};
    }
`;